import { motion } from "framer-motion";

export default function Pricing({ onBuy, loading }) {
  return (
    <section
      id="comprar"
      data-testid="pricing-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream-soft"
    >
      <div className="max-w-[1000px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="text-center mb-14"
        >
          <span className="section-num inline-flex mb-6">09 · Adquirir</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.02]">
            Um pequeno preço
            <br />
            para um <span className="font-serif-display text-orange normal-case lowercase">grande passo.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.4 }}
          className="bg-white border border-line"
          style={{ boxShadow: "0 30px 60px -20px rgba(31,29,27,0.18)" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-12">
            <div className="md:col-span-7 p-8 md:p-12 md:border-r border-line">
              <span className="smallcaps mb-3 block">Edição digital · PDF</span>
              <h3 className="font-display text-2xl md:text-3xl text-ink mb-8 leading-tight">
                Workbook completo
                <br />
                <span className="font-serif-display text-orange normal-case lowercase">quando já não dá para continuar igual.</span>
              </h3>
              <ul className="space-y-3">
                {[
                  "Acesso imediato após o pagamento",
                  "10 capítulos · 10 exercícios práticos",
                  "PDF pronto para imprimires em A4",
                  "Página de compromisso final",
                  "Atualizações da edição incluídas",
                ].map((b, i) => (
                  <li key={i} className="flex items-start gap-3" data-testid={`pricing-feature-${i}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E25A2C" strokeWidth="2" className="mt-1 flex-shrink-0">
                      <path d="M4 12l5 5L20 6" />
                    </svg>
                    <span className="text-ink">{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-5 bg-cream p-8 md:p-12 flex flex-col">
              <span className="smallcaps mb-3 block">Valor único</span>
              <div className="flex items-baseline gap-1 mb-1">
                <span className="font-display text-7xl md:text-[6rem] text-ink leading-none">29</span>
                <span className="font-display text-3xl text-orange">,90€</span>
              </div>
              <p className="text-sm text-ink-soft mb-8">IVA incluído · Pagamento único</p>
              <button
                onClick={onBuy}
                disabled={loading}
                data-testid="pricing-buy-button"
                className="btn-orange w-full px-6 py-4 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "A preparar..." : "Comprar agora"}
              </button>
              <div className="mt-5 pt-5 border-t border-line space-y-2">
                <div className="flex items-center gap-2 text-xs text-ink-soft">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  Pagamento seguro Stripe
                </div>
                <div className="flex items-center gap-2 text-xs text-ink-soft">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="6" width="18" height="13" rx="2" />
                    <line x1="3" y1="11" x2="21" y2="11" />
                  </svg>
                  Cartão · Apple Pay · Google Pay
                </div>
                <div className="flex items-center gap-2 text-xs text-ink-soft">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                  </svg>
                  Entrega imediata por email
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
